(() => {
  const strips = [...document.querySelectorAll('[data-itcc-curtain-strip]')];
  if (!strips.length) return;

  const HIDE_AFTER = 56;
  const SHOW_BEFORE = 8;
  const MIN_DELTA = 3;

  const pageWrapper = document.querySelector('.page-wrapper');
  const getScrollTop = () => {
    const winY = window.scrollY || document.scrollingElement?.scrollTop || 0;
    const wrapY = pageWrapper ? pageWrapper.scrollTop : 0;
    return Math.max(winY, wrapY);
  };

  const controllers = strips.map((root) => {
    const host = root.closest('.shopify-section') || root;
    let hidden = false;

    host.style.overflowAnchor = 'none';

    const setHidden = (nextHidden) => {
      if (nextHidden === hidden) return false;
      hidden = nextHidden;
      root.classList.toggle('is-curtain-hidden', hidden);
      root.toggleAttribute('inert', hidden);
      root.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      host.classList.toggle('is-curtain-collapsed', hidden);
      return true;
    };

    return { setHidden };
  });

  const setAllHidden = (nextHidden) => {
    let changed = false;
    for (const c of controllers) {
      if (c.setHidden(nextHidden)) changed = true;
    }
    return changed;
  };

  let lastY = getScrollTop();
  let ticking = false;
  let lenisBound = false;

  const applyFromScroll = (y, sourceDelta) => {
    const delta = typeof sourceDelta === 'number' ? sourceDelta : y - lastY;
    lastY = y;

    if (y <= SHOW_BEFORE) {
      setAllHidden(false);
      return;
    }

    if (y >= HIDE_AFTER && delta >= MIN_DELTA) {
      setAllHidden(true);
      return;
    }

    if (delta <= -MIN_DELTA) {
      setAllHidden(false);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      applyFromScroll(getScrollTop());
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  pageWrapper?.addEventListener('scroll', onScroll, { passive: true });

  const bindLenis = () => {
    if (lenisBound) return;
    const lenis = window.itccLenis || window.lenis || window.__lenis;
    if (!lenis || typeof lenis.on !== 'function') return;
    lenisBound = true;
    lenis.on('scroll', (e) => {
      const y = typeof e?.scroll === 'number' ? e.scroll : getScrollTop();
      if (typeof e?.direction === 'number' && e.direction !== 0) {
        const magnitude = Math.max(MIN_DELTA, Math.abs(y - lastY));
        applyFromScroll(y, e.direction * magnitude);
        return;
      }
      applyFromScroll(y);
    });
  };

  bindLenis();
  window.addEventListener('lenis:init', bindLenis);
  window.setTimeout(bindLenis, 400);
  window.setTimeout(bindLenis, 1200);
  window.setTimeout(bindLenis, 2500);

  applyFromScroll(getScrollTop(), 0);

  document.addEventListener('shopify:section:load', () => {
    lastY = getScrollTop();
    applyFromScroll(lastY, 0);
  });
})();
